import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import CategoriesTable from "../components/CategoriesTable";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const CategoriesPage = () => {
  return (
    <MasterLayout>
      <ToastContainer />
      <Breadcrumb title="Kategoriler" />
      <div className="dashboard-main active">
        <div className="container-fluid">
          <CategoriesTable />
        </div>
      </div>
    </MasterLayout>
  );
};

export default CategoriesPage;

